var s = window.s || {};

s.counters = {};

s.counters.google = [];
s.counters._hitGoogle = function(url, title, referer){
	try {
		if (window.ga) {
			ga(function(){
				var trackers = ga.getAll();
				for (var i=0; i < trackers.length; ++i) {
					trackers[i].send('pageview', {
						'page': url,
						'title': title,
						'referrer': referer
					});
				}
			});
		}
	} catch (e) {
		console.log(e);
	}
};
s.counters._eventGoogle = function(category, action, label, value){
	try {
		if (window.ga) {
			ga(function() {
				var trackers = ga.getAll();
				for (var i=0; i < trackers.length; ++i) {
					var fieldsObject = {
						eventCategory: category,
						eventAction: action
					};
					if (label) {
						fieldsObject.eventLabel = label;
					}
					if (value) {
						fieldsObject.eventValue = value;
					}
					
					trackers[i].send('event', fieldsObject);
				}
			});
		}
	} catch (e) {
		console.log(e);
	}
};

s.counters.yandex = [];
s.counters._hitYandex = function(url, title, referer){
	try {
		for (i = 0; i < this.yandex.length; i++) {
			var account = this.yandex[i];
			if (window["yaCounter"+account]) {
				window["yaCounter"+account].hit(url, {
					title: title,
					referer: referer
				});
			}
		}
	} catch (e) {
		console.log(e);
	}
};

s.counters.tns = [];
s.counters._hitTns = function(url, title, referer){
	// @see http://www.tns-metrix.ru/help/
	// tnsCounterXXXXXX.hit(tmsec, url, referrer);
	
	try {
		for (i = 0; i < this.tns.length; i++) {
			var account = this.tns[i];
			if (window["tnsCounter"+account.account]) {
				window["tnsCounter"+account.account].hit(account.tmsec, url, referer);
			}
		}
	} catch (e) {
		console.log(e);
	}
};

s.counters.adwolf = {
	_placeholderId: 'AdwolfBanner!!!x!!!_968948',
	_audioCounterUrl: '//a.adwolf.ru/getCode?p1=bbat&p2=hh&ptrc=b&pfc=a&pfb=a&pr=etdldja',
	hitPage: function(){
		if (window.Adwolf)
		{
			var el = document.getElementById(this._placeholderId);
			if (el)
			{
				// Reset flag to force repeat script loading
				el.AdwolfLoaded = false;
				// Remove previous script tag
				el.parentNode.removeChild(el.previousElementSibling || el.previousSibling);
			}
			else
			{
				s.dom.$body.append('<div id="'+this._placeholderId+'" ></div>');
			}

			new Adwolf(
				{
					placeholderId: this._placeholderId,
					width: 0,
					height: 0,
					link: document.location.protocol+'//a.adwolf.ru/prepareCode?pp=cl&ps=cgt&p2=hh&pct=a&plp=a&pli=a&pop=a&pr='
				},
				{puids:{}},
				{paps:{}},
				{mechanics:2}
			);
		}
	},
	hitAudio: function(){
		$.ajax({
			url: document.location.protocol+this._audioCounterUrl,
			dataType: "script",
			async: true,
			cache: false
		});
	}
};

s.counters.init = function(){
	var self = this;
	s.dom.$window.on("counters.hit", function(e, url, title, referer){
		window.setTimeout(function(){
			var i, docTitle = document.title;
			title && (document.title = title);
			
			self._hitGoogle(url, title, referer);
			self._hitYandex(url, title, referer);
			self._hitTns(self.tns[i], url, title, referer);
			self.adwolf.hitPage();
			
			title && (document.title = docTitle);
		}, 0);
	});
	s.dom.$window.on("counters.event", function(e, category, action, label, value){
		window.setTimeout(function(){
			s.counters._eventGoogle(category, action, label, value);
		}, 0);
	});
};